import { MoneySchema } from "@redotech/money";
import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getLoyaltyCustomerInfo = {
  name: "getLoyaltyCustomerInfo" as const,
  input: z.object({
    customerId: z.string(),
    currency: createEnum(Currency),
    storeUrl_forCacheRoutingOnly: z.string(),
  }),
  output: z.object({
    pointsBalance: z.number(),
    singlePointValue: MoneySchema,
    loyaltyDashboardUrl: z.string().optional(),
    customerName: z.string().optional(),
  }),
};
